import { render, staticRenderFns } from "./ColorSchemeBox.vue?vue&type=template&id=068632ea&scoped=true&"
import script from "./ColorSchemeBox.vue?vue&type=script&lang=js&"
export * from "./ColorSchemeBox.vue?vue&type=script&lang=js&"
import style0 from "./ColorSchemeBox.vue?vue&type=style&index=0&id=068632ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068632ea",
  null
  
)

export default component.exports